import { defineStore } from "pinia";
import { ref } from "vue";
import { differenceInCalendarDays, parseISO } from "date-fns";

export const useAccessRenewalModalStore = defineStore("accessRenewalModal", () => {
    const isOpen = ref(false);
    const DEFAULT_STORAGE_KEY = "accessRenewalModalLastShown";

    const getStorageKey = (userScope?: string | null) => {
        return userScope
            ? `${DEFAULT_STORAGE_KEY}:${userScope}`
            : DEFAULT_STORAGE_KEY;
    };

    const getLastShownDate = (userScope?: string | null) => {
        return localStorage.getItem(getStorageKey(userScope));
    };

    const setLastShownDate = (date: string, userScope?: string | null) => {
        localStorage.setItem(getStorageKey(userScope), date);
    };

    const open = () => {
        isOpen.value = true;
    };

    const close = (userScope?: string | null) => {
        isOpen.value = false;
        setLastShownDate(new Date().toISOString().split("T")[0], userScope);
    };

    const SHOW_ONCE_WINDOW_DAYS = 7;

    const hasBeenShownWithinWindow = (userScope?: string | null) => {
        const lastShownDate = getLastShownDate(userScope);

        if (!lastShownDate) return false;

        return differenceInCalendarDays(new Date(), parseISO(lastShownDate)) < SHOW_ONCE_WINDOW_DAYS;
    };

    const shouldShowModal = (userScope?: string | null) => !hasBeenShownWithinWindow(userScope);

    return {
        isOpen,
        getStorageKey,
        hasBeenShownWithinWindow,
        shouldShowModal,
        open,
        close,
    };
});
